module.exports = __webpack_public_path__ + "img/Noroeste.e13fe7af.svg";